import { withResetFormValues } from '../../hocs/withResetFormValues'
import { OptionOne as Component } from './OptionOne'

export const OptionOne = withResetFormValues(Component)
